import React, { useState, useEffect, useContext } from 'react';
import { Dialog } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { UserInfoDialogContext } from '../../../store/context/userInfoDialogContext';
import { NetCallContext } from '../../../store/context/netCallContext';
import { CallType, CalloutState, DialogType } from './commonUtil';
import { CallTypeComponent } from './NetCallTypeComponent';
import { RegexFactory } from '../../../consts/RegexFactory';

const CallConfirmDialog = (props) => {
  const context = useContext(UserInfoDialogContext);
  const netCallContext = useContext(NetCallContext);
  const [userData, setUserData] = useState({});
  const [callType, setCallType] = useState(CallType.NET);
  const [dialogType, setDialogType] = useState(DialogType.NEED_CHECK);
  const [errMsg, setErrMsg] = useState('');
  useEffect(() => {
    RPCFactory.operationUser
      .getLoginUserInfo(window.pageProps.uid)
      .done((data) => {
        setUserData(data);
      })
      .fail(() => {});
  }, []);

  useEffect(() => {
    RPCFactory.operationUser
      .getLoginUserInfo(window.pageProps.uid)
      .done((data) => {
        setUserData(data);
      })
      .fail(() => {});
  }, [context.showUserInfoDialog]);

  useEffect(() => {
    if (netCallContext.socket && props.show) {
      netCallContext.createRoom();
    }
    if (dialogType == DialogType.NEED_CHECK && props.leadsId && props.show) {
      RPCFactory.call
        .checkCallAccountValid(window.pageProps.uid, props.leadsId)
        .done(() => {
          checkDialogType({ accountCouldCallPara: true });
        })
        .fail((_ret, msg) => {
          checkDialogType({ accountCouldCallPara: false, msg });
        });;
    }
  }, [props.show]);

  const checkDialogType = ({ accountCouldCallPara, msg }) => {
    let dialogType = DialogType.SELECT_OPTION;
    const showCallStateComponent = netCallContext.calloutState != CalloutState.NOT_START;
    const showLoginStateComponent = netCallContext.netCallLoggedIn;
    const telValid = RegexFactory.encodeTelRegex.test(props.callee)
    || RegexFactory.operationUserTelRegex.test(props.callee);
    if (
      window.pageProps.originRole == 'OPERATOR_ROLE_LEADS_OBSERVER' ||
      window.pageProps.originRole == 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER'
    ) {
      dialogType = DialogType.ACCOUNT_FREELOGIN;
    } else if (!accountCouldCallPara) {
      dialogType = DialogType.ACCOUNT_INVALID;
      setErrMsg(msg);
    } else if(!telValid) {
      dialogType = DialogType.TEL_INVALID;
    } else if(showCallStateComponent) {
      dialogType = DialogType.CALLING;
    } else if(showLoginStateComponent && !showCallStateComponent) {
      dialogType = DialogType.CONFIRM_CALL;
    } else if (!showLoginStateComponent) {
      dialogType = DialogType.SELECT_OPTION;
    }
    setDialogType(dialogType);
  };
  const onCancelShow = () => {
    props.onCancel();
    setDialogType(DialogType.NEED_CHECK);
  };
  const onShowUserInfoDialog = () => {
    context.setUserInfoDialog(true);
    onCancelShow();
  };
  const onConfirmCallType = () => {
    // 使用网络电话
    if (callType == CallType.NET) {
      if (netCallContext.socket == null) { // 登录网络电话
        // setSocket(io(wsUrl, { query: { accountId: pageProps.uid, userId: pageProps.operationUserId } }));
        netCallContext.initSocket();
      } else if (netCallContext.socket.disconnect) {
        netCallContext.socket.connect();
      }
      onCancelShow();
    } else {
      // 外呼电话呼出
      props.onSubmit();
    }
  };
  const startCall= () => {
    const callDetailInfo = {
      calleeName: props.name,
      calleePhoneNum: props.callee,
      calleePhoneLoc: props.location,
      leadsId: props.leadsId,
      tags: props.tags,
      updateTagsCallback: props.updateTagsCallback,
    };
    netCallContext.onCallUserUsingNetCall(callDetailInfo);
    onCancelShow();
  };
  const selectType = (type) => {
    setCallType(type);
  };
  const renderCallTypeSelectorContent = (type) => {
    if (type == CallType.NET_OPTION) {
      return (
        <span className="info">
          登录后默认使用网络电话，通过电脑音频进行电话沟通，保持登录状态可以接听到用户回拨电话
        </span>);
    }
    if (type == CallType.NORMAL_OPTION) {
      return (
        <div>
          <span className="info">系统将通过中间号给您预设的手机号码({userData.phone}</span>
            <span className="edit" onClick={onShowUserInfoDialog}>
              修改
            </span>
            <span className="info">)拨打电话，接通后即会呼叫({props.callee})</span>
        </div>);
    }
    if (type == CallType.NET) {
      return (
        <span className="info">
          系统将使用网络电话呼叫手机号({props.callee})，为了提升通话质量，建议初次通话前进行通话质量检测。退出网络电话登录后，可切换使用外呼电话。
        </span>);
    }
    if (type == CallType.NORMAL) {
      return (
        <div>
          <span className="info">系统将通过中间号给您预设的手机号码({userData.phone}</span>
            <span className="edit" onClick={onShowUserInfoDialog}>
              修改
            </span>
            <span className="info">)拨打电话，接通后即会呼叫({props.callee})</span>
        </div>);
    }
  };
  return (
    <div>
      {(dialogType == DialogType.SELECT_OPTION) && (
        <Dialog
          type="normal"
          className="spaui-dialog-confirm-normal modal-lead-calling calling-options"
          title="选择呼叫方式"
          show={props.show}
          onClose={onCancelShow}
          onCancel={onCancelShow}
          onSubmit={onConfirmCallType}
          submitLabel={callType == CallType.NET ? '登录网络电话' : '呼叫用户'}
          style={{ width: '800px' }}
        >
          <div className='select-call-type'>
            <CallTypeComponent
                active={callType == CallType.NET}
                callType={CallType.NET}
                title={'网络电话'}
                renderContent={() => renderCallTypeSelectorContent(CallType.NET_OPTION)}
                selectType={selectType}
              />
              <CallTypeComponent
                active={callType != CallType.NET}
                callType={CallType.NORMAL}
                title={'外呼电话'}
                renderContent={() => renderCallTypeSelectorContent(CallType.NORMAL_OPTION)}
                selectType={selectType}
              />
          </div>
        </Dialog>
      )}
      {(dialogType == DialogType.CONFIRM_CALL) && (
        <Dialog
          type="normal"
          className="spaui-dialog-confirm-normal modal-lead-calling"
          enabledBackdropClose
          show={props.show}
          onClose={onCancelShow}
          onCancel={onCancelShow}
          onSubmit={startCall}
          submitLabel={'呼叫用户'}
          disabled={!netCallContext.netCallLoggedIn}
          style={{ width: '605px' }}
        >
          <div className='select-call-type selected'>
            <CallTypeComponent
              active={callType == CallType.NET}
              callType={CallType.NET}
              title={'网络电话'}
              renderContent={() => renderCallTypeSelectorContent(CallType.NET)}
              selectType={selectType}
            />
          </div>
        </Dialog>
      )}
      {(dialogType == DialogType.CALLING) && (
        <Dialog
          time={2000}
          timeCallback={onCancelShow}
          type='tip'
          iconType='strongwarn'
          show={props.show}
        >
          <div>正在通话中，请挂断后再呼叫</div>
        </Dialog>
      )}
      {(dialogType == DialogType.TEL_INVALID) && (
        <Dialog
          time={2000}
          timeCallback={onCancelShow}
          type='tip'
          iconType='strongwarn'
          show={props.show}
        >
          <div>您拨叫的电话有误</div>
        </Dialog>
      )}
      {(dialogType == DialogType.ACCOUNT_INVALID) && (
        <Dialog
          time={2000}
          timeCallback={onCancelShow}
          type='tip'
          iconType='strongwarn'
          show={props.show}
        >
          <div>{errMsg}</div>
        </Dialog>
      )}
      {(dialogType == DialogType.ACCOUNT_FREELOGIN) && (
        <Dialog
          time={2000}
          timeCallback={onCancelShow}
          type='tip'
          iconType='strongwarn'
          show={props.show}
        >
          <div>没有操作权限</div>
        </Dialog>
      )}
    </div>
  );
};
export default CallConfirmDialog;
